// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"0c85efd4","141":"0c85efd4","203":"0c85efd4","231":"0c85efd4","424":"0c85efd4","531":"d906eed7","534":"0c85efd4","545":"0c85efd4","884":"0c85efd4","912":"0c85efd4"}[chunkId] + ".chunk.css";
};